<template>
  <div class="item-container" :class="{ 'read': notification.is_read }" @click="handleClick" data-testid="notification-item">
    <div class="notification-icon" :class="{ 'check-icon': notification.type !== 'notification' }" data-testid="notification-icon">
      <BellOutline :size="19" v-if="notification.type === 'notification'" data-testid="bell-icon" />
      <Check :size="19" v-else data-testid="check-icon" />
    </div>

    <div class="notification-content" data-testid="notification-content">
      <strong data-testid="notification-title">{{ truncatedTitle }}</strong>
      <span data-testid="notification-time">{{ relativeTime(notification.created_at) }}</span>
    </div>

    <span v-if="!notification.is_read" class="dot" data-testid="unread-dot"></span>
  </div>
</template>

<script>
import File from "icons/File"
import BellOutline from "icons/BellOutline"
import Check from "icons/Check"

export default {
  components: {
    File,
    BellOutline,
    Check,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    }
  },
  computed: {
    truncatedTitle() {
      if (this.notification.title && this.notification.title.length > 32) {
        return this.notification.title.substring(0, 32) + '...';
      }
      return this.notification.title;
    }
  },
  methods: {
    handleClick() {
      this.$emit('notification-click', this.notification.id)
    },
    relativeTime(dateString) {
      const now = new Date();
      const date = new Date(dateString);

      const diff = now - date;

      const minutes = Math.floor(diff / (1000 * 60));
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));

      const monthNames = [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ];

      const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

      if (days === 0) {
        if (hours === 0) {
          return `Hoje • ${minutes} min`;
        } else {
          return `Hoje • ${hours} h`;
        }
      } else if (days === 1) {
        return `Ontem • ${formattedTime}`;
      } else {
        const day = date.getDate();
        const month = monthNames[date.getMonth()];
        return `${day} de ${month}`;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.item-container {
  background-color: #e0e0e098;
  border-radius: 14px;
  padding: 0.75rem;
  cursor: pointer;

  &:hover {
    background-color: #d0d0d098;
  }

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;

  &.read {
    background-color: transparent;
  }

  .notification-icon {
    padding: 0.25rem 0.55rem 0.45rem;
    background-color: rgba(255, 224, 129, 0.4);
    border-radius: 10px;

    color: #ffc20e;

    &.check-icon {
      background-color: rgba(76, 175, 80, 0.2);
      color: #4caf50;
    }
  }

  .notification-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    strong {
      font-size: 0.75rem;
      font-weight: 700;
    }

    span {
      font-size: 0.65rem;
      font-weight: 600;
    }
  }

  .dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: #ffc20e;
    border-radius: 50%;
  }
}
</style>